import { environment } from '../../environments/environment';

// The session_token in the URL is only decoded, never verified: anyone can craft one. Its
// continue_uri and backUrl are therefore never used as navigation targets (FW-02, FW-03).

// Auth0's /continue endpoint of this environment's tenant, with the state URL-encoded.
export function continueUrl(state: string, params: Record<string, string> = {}): string {
  const query = new URLSearchParams({ state, ...params });
  return `https://${environment.auth.domain}/continue?${query}`;
}

// The backUrl if it is an https URL on one of the allowlisted origins, otherwise null.
export function allowedBackUrl(backUrl: string | null | undefined): string | null {
  if (!backUrl) {
    return null;
  }
  try {
    const url = new URL(backUrl);
    return url.protocol === 'https:' && environment.backUrlOrigins.includes(url.origin)
      ? backUrl
      : null;
  } catch {
    return null;
  }
}
